import { makeImmutable } from "../../core/makeImmutable";
export class ProductInstanceVariant {
    constructor(params) {
        this.productTypes = params.productTypes;
        this.customParameterChoices = params.customParameterChoices;
        makeImmutable(this);
    }
}
